import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import UserSelectRepository from '@/repositories/userSelectRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useUserSelectStore = defineStore({
    id: 'userSelect',
    state: () => ({
        UserList: [],
        pageInfo: 0,
    }),
    getters: {},
    actions: {
        /**
         * ユーザー選択API
         * @param {String} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getUserSelectAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const userSelectRepository = new UserSelectRepository();

            try {
                const response = await userSelectRepository.getUserSelectApi(API_URL, requestBody, idToken);

                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }

                this.UserList = response.data.List;
                this.pageInfo = response.data.PageInfo.RowResult;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        reset() {
            this.UserList = [];
            this.pageInfo = 0;
        },
    },
    persist: {
        storage: sessionStorage,
    },
});
